<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <v-row no-gutters class="mb-5">
      <v-col cols="12" md="9">
        <h2>{{ hipotekaTitle }}</h2>
        <div class="zug-info" v-if="showZugInfo">
          {{ this.tabInfo.zug_numeris }}
          {{ this.tabInfo.zug_identifikavimo_kodas }}
        </div>
      </v-col>
      <v-col cols="12" md="3" class="text-right pt-5">
        <el-button v-if="showToList" @click.native="toList()" x-small
          >Grįžti į sąrašą</el-button
        >
      </v-col>
      <v-col cols="12" md="12" class="text-right mt-0 pt-0">
        <el-busena
          class="mt-2"
          :busena="laukiaPatvirtinimoText"
          v-if="tabInfo.laukia_patvirtinimo"
        />
        <el-busena
          class="mt-2"
          busena="Laukia pasirašymo"
          v-if="tabInfo.zug_pasirasymas_vadovas"
        />
        <el-hipoteka-busena class="mt-2" :busena="tabInfo.obj_busena" />
        <el-busena
          v-if="showTikrina"
          class="mt-2"
          color="green"
          :busena="tikrinaText"
        />
        <el-busena
          v-if="showVykdo"
          class="mt-2"
          color="green"
          :busena="vykdoText"
        />
      </v-col>
    </v-row>
    <check-errors />
    <template v-if="isLock">
      <v-card>
        <v-card-text>
          <v-alert class="mt-5 mb-5" dense outlined type="error">
            Dokumentas redaguojamas
          </v-alert>
        </v-card-text>
      </v-card>
    </template>
    <template v-if="isLoaded">
      <v-sheet class="d-flex justify-start" color="transparent">
        <v-card flat style="width: 200px;" color="transparent" class="mr-5">
          <v-card>
            <v-list dense>
              <v-list-item-group
                v-model="selectedTab"
                color="primary"
                mandatory
              >
                <v-list-item
                  v-for="(item, i) in filteredTabItems"
                  :key="i"
                  @click="gotoTab(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      :class="tabClass(item)"
                      v-text="item.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-card>
        <v-card v-if="activeTab >= 0" width="100%" :min-width="dataMinWidth">
          <component
            :key="`component-${objektasID}`"
            :is="tabItems[activeRoute].component"
            :readonly-form="tabItems[activeRoute].readonly"
            class="tabComponent"
          ></component>
        </v-card>
        <v-card
          v-if="activeTab < 0"
          width="100%"
          :min-width="dataMinWidth"
          class="pa-5"
        >
          <v-alert dense outlined type="error"
            >Neturite teisių matyti šios informacijos.</v-alert
          >
        </v-card>
      </v-sheet>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import UnsavedData from '../modals/UnsavedData'
import CheckErrors from './CheckErrors'
import unsavedDataRoute from '../../mixins/unsavedDataRoute'
import hipotekaTabs from '../../mixins/hipotekaTabs'
import HipotekaMap from './hipotekaMap'
import userRole from '../../mixins/userRole'
import busena from '../../mixins/busena'

import HipotekaPranesimas from './HipotekaPranesimas'
import HipotekaTeikejas from './HipotekaTeikejas'
import HipotekaSkolininkai from './HipotekaSkolininkai'
import HipotekaIkaitoDavejai from './HipotekaIkaitoDavejai'
import HipotekaIkaitoDavejaiHR from './HipotekaIkaitoDavejaiHR'
import HipotekaKreditoriai from './HipotekaKreditoriai'
import HipotekaTurtas from './turtas/HipotekaTurtas'
import HipotekaPrievole from './prievole/HipotekaPrievole'
import HipotekaSandoris from './HipotekaSandoris'
import HipotekaNustatymas from './HipotekaNustatymas'
import HipotekaVykdomasis from './HipotekaVykdomasis'
import HipotekaSalyginis from './HipotekaSalyginis'
import HipotekaKitaInfo from './HipotekaKitaInfo'
import HipotekaRinkmenos from './HipotekaRinkmenos'
import HipotekaInformavimas from './HipotekaInformavimas'
import HipotekaRegistravimas from './registravimas/HipotekaRegistravimas'

import SutartisSalys from './../sutartis/SutartisSalys'
import SutartisInfo from './../sutartis/SutartisInfo'
import SutartisDaiktas from './../sutartis/SutartisDaiktas'

export default {
  name: 'HipotekaTab',
  components: { UnsavedData, CheckErrors },
  mixins: [userRole, busena, hipotekaTabs, unsavedDataRoute],
  data() {
    return {
      selectedTab2: null,
      pageloading: true,
      bylosSegamos: false,
      tabInfo: {
        obj_dokumento_numeris: null,
      },
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'hipotekaBusena',
      'hipotekaBusenaTolimesne',
      'hipotekaReadonly',
      'objektasVeiksmas',
      'objektasSalyginis',
      'perduodamasKreditoriui',
      'appSavitarna',
      'listInfo',
    ]),
    routeItems() {
      return {
        hipotekaPranesimas: {
          component: HipotekaPranesimas,
          readonly: this.isReikalavimoPerleidimas,
        },
        hipotekaTeikejas: {
          component: HipotekaTeikejas,
          hide: false,
          readonly:
            this.isAntstolis || this.isAdresas || this.isReikalavimoPerleidimas,
        },
        hipotekaSkolininkai: {
          component: HipotekaSkolininkai,
          hide: !this.isHipoteka,
          readonly:
            this.isVykdomasis ||
            this.isPabaiga ||
            this.isAntstolis ||
            this.isArchyvas ||
            this.isReikalavimoPerleidimas,
        },
        hipotekaIkaitoDavejai: {
          component: HipotekaIkaitoDavejai,
          hide: !(this.isSavitarna && this.isHipoteka),
          readonly:
            this.isVykdomasis ||
            this.isPabaiga ||
            this.isAntstolis ||
            this.isArchyvas ||
            this.isReikalavimoPerleidimas,
        },
        hipotekaIkaitoDavejaiHR: {
          component: HipotekaIkaitoDavejaiHR,
          hide: !this.showIkaitoDavejasHR,
          readonly: this.isReikalavimoPerleidimas,
        },
        hipotekaKreditoriai: {
          component: HipotekaKreditoriai,
          hide: !this.isHipoteka,
          readonly:
            this.isVykdomasis ||
            this.isPabaiga ||
            this.isAntstolis ||
            this.isArchyvas,
        },
        hipotekaTurtas: {
          component: HipotekaTurtas,
          hide: !this.isHipoteka,
          forceActive: this.isAdresas,
          readonly:
            this.isVykdomasis ||
            this.isPabaiga ||
            this.isArchyvas ||
            this.isAdresas ||
            this.isReikalavimoPerleidimas,
        },
        turtasObjektas: {
          component: HipotekaTurtas,
          hide: true,
          readonly:
            this.isVykdomasis ||
            this.isPabaiga ||
            this.isArchyvas ||
            this.isAdresas ||
            this.isReikalavimoPerleidimas,
        },
        hipotekaPrievole: {
          component: HipotekaPrievole,
          hide: !this.isHipoteka,
          readonly:
            this.isVykdomasis ||
            this.isPabaiga ||
            this.isAntstolis ||
            this.isArchyvas ||
            this.isAdresas ||
            this.isReikalavimoPerleidimas,
        },
        prievoleObjektas: {
          component: HipotekaPrievole,
          hide: true,
          readonly:
            this.isVykdomasis ||
            this.isPabaiga ||
            this.isAntstolis ||
            this.isArchyvas ||
            this.isAdresas ||
            this.isReikalavimoPerleidimas,
        },
        hipotekaSandoris: {
          component: HipotekaSandoris,
          hide: this.hideSandoris,
          readonly:
            !this.showSandoris ||
            this.isAntstolis ||
            this.isArchyvas ||
            this.isAdresas ||
            this.isReikalavimoPerleidimas,
        },
        hipotekaNustatymas: {
          component: HipotekaNustatymas,
          hide: this.hideNustatymas,
          readonly:
            !this.showNustatymas ||
            this.isAntstolis ||
            this.isArchyvas ||
            this.isAdresas ||
            this.isReikalavimoPerleidimas,
        },
        hipotekaSalyginis: {
          component: HipotekaSalyginis,
          hide: !this.isSutartinis,
          readonly:
            this.isVykdomasis ||
            !this.showSalyginis ||
            this.isPabaiga ||
            this.isAntstolis ||
            this.isArchyvas ||
            this.isAdresas ||
            this.isReikalavimoPerleidimas,
        },
        hipotekaVykdomasis: {
          component: HipotekaVykdomasis,
          hide: !this.showVykdomasis || !this.isHipoteka,
          readonly:
            !this.isVykdomasis ||
            this.isPabaiga ||
            this.isAntstolis ||
            this.isArchyvas ||
            this.isAdresas ||
            this.isReikalavimoPerleidimas,
        },
        hipotekaKitaInfo: {
          component: HipotekaKitaInfo,
          hide: !this.isHipoteka,
          readonly:
            this.isVykdomasis ||
            this.isPabaiga ||
            this.isAntstolis ||
            this.isArchyvas ||
            this.isAdresas ||
            this.isReikalavimoPerleidimas,
        },
        sutartisSalys: {
          component: SutartisSalys,
          hide: !this.isSutartis,
          readonly: this.sutartisSalysReadonly || this.isAntstolis,
        },
        sutartisInfo: {
          component: SutartisInfo,
          hide: !this.isSutartis,
          readonly: this.sutartisInfoReadonly || this.isAntstolis,
        },
        sutartisDaiktas: {
          component: SutartisDaiktas,
          hide: !this.isSutartis,
          readonly: this.sutartisDaiktasReadonly || this.isAntstolis,
        },
        hipotekaRinkmenos: {
          component: HipotekaRinkmenos,
          hide: !this.isHipoteka || this.isSavitarna,
          readonly: !this.bylosSegamos,
        },
        hipotekaInformavimas: {
          component: HipotekaInformavimas,
          hide: false,
          readonly: this.isReikalavimoPerleidimas,
        },
        hipotekaRegistravimas: {
          component: HipotekaRegistravimas,
          readonly: false,
        },
      }
    },
    tabHipotekaTipas() {
      return this.hipotekaTipas
    },
    tabItems() {
      return Object.entries(this.routeItems).map(([key, item]) => {
        return {
          ...item,
          ...(this.hipotekaTabs[key] ?? []),
        }
      })
    },
    filteredTabItems() {
      return this.tabItems.filter(item => {
        return !item.hide
      })
    },
    selectedTab: {
      set(value) {
        // this.activeTab = value
      },
      get() {
        return this.activeTab
      },
    },
    activeTab: {
      set(value) {
        // this.selectedTab = value
      },
      get() {
        return this.filteredTabItems.findIndex(function(item, index) {
          return this.$route.matched.find(element => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.tabItems.findIndex(function(item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
    compHipotekaTipasTitle() {
      return HipotekaMap['hipotekaTipas'][this.hipotekaTipas]
        ? HipotekaMap['hipotekaTipas'][this.hipotekaTipas].title
        : this.hipotekaTipas
    },
    hipotekaTitle() {
      if (!this.hipotekaTipas) {
        return ''
      }
      return (
        this.compHipotekaTipasTitle +
        (this.tabInfo.obj_dokumento_numeris
          ? ' Nr. ' + this.tabInfo.obj_dokumento_numeris
          : '')
      )
    },
    hideSandoris() {
      return (
        !(
          (this.roleOr([
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
          ]) ||
            (this.roleRG && this.showSandoris) ||
            (this.isSavitarna && this.showSandoris)) &&
          this.isSutartinis &&
          !this.isVykdomasis
        ) ||
        (this.isHipoteka && this.isPabaiga)
      )
    },
    showSandoris() {
      return this.objektasVeiksmas === 1
    },
    hideNustatymas() {
      return (
        !(
          (this.roleOr([
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
          ]) ||
            (this.roleRG && this.showNustatymas)) &&
          this.isPriverstinis &&
          !this.isVykdomasis
        ) ||
        (this.isHipoteka && this.isPabaiga)
      )
    },
    showNustatymas() {
      return this.objektasVeiksmas === 1 && !this.isVykdomasis
    },
    showSalyginis() {
      return this.objektasSalyginis
    },
    showVykdomasis() {
      return this.tabInfo.obj_vykdomasis
    },
    isHipoteka() {
      return this.isSutartinis || this.isPriverstinis
    },
    isSutartinis() {
      return this.hipotekaTipas.includes('sutartinis')
    },
    isPriverstinis() {
      return this.hipotekaTipas.includes('priverstinis')
    },
    isSutartis() {
      return this.hipotekaTipas.includes('sutartis')
    },
    isNeisregistruoti() {
      return this.hipotekaTipas.includes('neisregistruoti')
    },
    isPageidavimas() {
      return this.hipotekaTipas.includes('pageidavimas')
    },
    isAtsaukimas() {
      return this.hipotekaTipas.includes('atsaukimas')
    },
    isVykdomasis() {
      return this.hipotekaTipas.includes('vykdomasis')
    },
    isPakeitimas() {
      return this.hipotekaTipas.includes('pakeitimas')
    },
    isPabaiga() {
      return (
        this.hipotekaTipas.includes('pabaiga') ||
        this.hipotekaTipas.includes('panaikinimas')
      )
    },
    isArchyvas() {
      return this.hipotekaTipas.includes('archyvas')
    },
    isAdresas() {
      return (
        this.hipotekaTipas.includes('adresas') &&
        (this.isRengiamas || this.isGrazintas || this.isPerduotas)
      )
    },
    isAntstolis() {
      return this.role(['DT_antstolis'])
    },
    isLock() {
      return this.tabInfo.obj_uzrakinta
    },
    isLoaded() {
      return !this.isLock && !this.pageloading
    },
    sutartisSalysReadonly() {
      return this.isPabaiga || this.isNeisregistruoti
    },
    sutartisInfoReadonly() {
      return (
        this.isPabaiga ||
        this.isNeisregistruoti ||
        this.isPageidavimas ||
        this.isAtsaukimas
      )
    },
    sutartisDaiktasReadonly() {
      return (
        this.isPabaiga ||
        this.isNeisregistruoti ||
        this.isPageidavimas ||
        this.isAtsaukimas
      )
    },
    laukiaPatvirtinimoText() {
      return `Laukia ${this.tabInfo.zug_registratoriai_aktyvus ??
        ''} patvirtinimo`
    },
    tikrinaText() {
      return `Tikrina ${this.tabInfo.zug_tikrina ?? ''}`
    },
    vykdoText() {
      return `Vykdo ${this.tabInfo.zug_vykdytojas ?? ''}`
    },
    isSavitarna() {
      return this.appSavitarna
    },
    dataMinWidth() {
      return this.isSavitarna ? '550px' : '800px'
    },
    showIkaitoDavejasHR() {
      return this.tabInfo.ikaito_davejas_hr
    },
    showZugInfo() {
      return this.roleRGV
    },
    showToList() {
      return this.listInfo.obj_id === this.objektasID
    },
    isReikalavimoPerleidimas() {
      return this.tabInfo.zug_pagrindas === 'reikalavimo_perleidimas_auto'
    },
    showTikrina() {
      return (
        this.tabInfo.zug_tikrina &&
        this.roleRG &&
        !this.isIregistruotas &&
        !this.isAtmestas
      )
    },
    showVykdo() {
      return (
        this.tabInfo.zug_vykdytojas &&
        this.roleRG &&
        !this.isIregistruotas &&
        !this.isAtmestas
      )
    },
  },
  beforeCreate() {
    this.$root.$off('updateDokumentasNr')
    this.$root.$off('reloadHipotekaTab')
  },
  beforeDestroy() {
    // if (!this.hipotekaReadonly) {
    this.$store.dispatch('unlockObj', {
      obj_id: this.objektasID,
      lock: false,
    })
    // }
  },
  created() {
    this.$root.$on('updateDokumentasNr', DocNr => {
      this.updateDokumentasNr(DocNr)
    })
    this.$root.$on('reloadHipotekaTab', () => {
      this.getData()
    })
    this.$store.dispatch('checkErrors', null)
    this.defaultRouteParams()
    this.getData()
  },
  methods: {
    defaultRouteParams() {
      if (this.$route.params.objektasID) {
        this.$store.dispatch('objektasID', this.$route.params.objektasID)
      }
      if (this.$route.params.turtasID) {
        this.$store.dispatch('turtasID', this.$route.params.turtasID)
      }
      if (this.$route.params.turtasRusis) {
        this.$store.dispatch('turtasRusis', this.$route.params.turtasRusis)
      }
      if (this.$route.params.prievoleID) {
        this.$store.dispatch('prievoleID', this.$route.params.prievoleID)
      }
      if (this.$route.params.vykdomasisID) {
        this.$store.dispatch('vykdomasisID', this.$route.params.vykdomasisID)
      }
    },
    getData() {
      this.$axios
        .get(`objektas/${this.objektasID}/hipotekatab`)
        .then(res => {
          this.tabInfo = res.data.hipoteka_tab
          this.bylosSegamos = res.data.bylos_segamos

          if (
            this.tabInfo.zug_pasirasymas_vadovas &&
            this.tabInfo.obj_busena !== 'rengiamas'
          ) {
            this.tabInfo.obj_readonly = true
          }
          if (this.roleSkaitytojas) {
            this.tabInfo.obj_readonly = true
          }

          this.$store.dispatch('hipotekaTipas', this.tabInfo.obj_tipas)
          this.$store.dispatch('hipotekaBusena', this.tabInfo.obj_busena)
          this.$store.dispatch('hipotekaReadonly', this.tabInfo.obj_readonly)
          this.$store.dispatch('hipotekaOwner', this.tabInfo.is_owner)

          this.$store.dispatch(
            'hipotekaBusenaTolimesne',
            this.tabInfo.zug_busena_tolimesne
          )

          this.$store.dispatch(
            'pasirasymasVadovas',
            this.tabInfo.zug_pasirasymas_vadovas
          )
          this.$store.dispatch('signStatus', this.tabInfo.sign_status)

          this.$store.dispatch(
            'objektasVeiksmas',
            this.tabInfo.obj_veiksmas ?? 0
          )
          this.$store.dispatch('objektasRusys', this.tabInfo.obj_rusys)
          this.$store.dispatch(
            'objektasSalyginis',
            this.tabInfo.obj_rusys.salyginis
          )
          this.$store.dispatch(
            'perduodamasKreditoriui',
            this.tabInfo.obj_kita_perduodamas_kreditoriui
          )
          this.$store.dispatch(
            'dokumentasSavitarna',
            this.tabInfo.dokumento_sistema === 'savitarna'
          )
          this.$store.dispatch(
            'objektasSavitarna',
            this.tabInfo.objekto_sistema === 'savitarna'
          )
          this.$store.dispatch(
            'registratoriaiAktyvus',
            this.tabInfo.zug_registratoriai_aktyvus
          )
          this.$store.dispatch('lockObj', {
            obj_id: this.objektasID,
            lock: !this.tabInfo.obj_readonly,
          })
        })
        .catch(err => {
          if (err.response && err.response.status === 404) {
            this.$router.push({ name: 'home' })
          }
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
    tabClass(item) {
      return 'tabItem ' + (item.readonly && !item.forceActive ? 'readonly' : '')
    },
    updateDokumentasNr(DocNr) {
      this.tabInfo.obj_dokumento_numeris = DocNr
    },
    toList() {
      this.$router.push({
        name: this.listInfo.routeName,
        params: {
          toList: true,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
.tabItem {
  &.readonly {
    color: $secondary;
  }
}
.tabComponent {
  margin: 0 auto 0 0;
}
.zug-info {
  font-size: 0.8rem;
  opacity: 0.8;
}
</style>
